import { CHAT_FILTER_TYPES } from '../../../constants';
import { FiltersState } from '../../../states/chat-list';
import { ChatStatuses, ChatStatusFilters } from '../../../typings';
import { GetChatStatusFilterCount } from '../../chat-list-section/chat-row/typings';

const labelForStatus = (status: ChatStatuses): string => {
  return ChatStatusFilters.find((o) => o.value === status)?.name ?? status;
};

/** Mirrors CRM ESSearchChatTypeFilterStatus: which statuses appear under each inbox tab. */
const STATUS_ROWS_BY_FILTER_TYPE: Record<
  keyof Pick<typeof FiltersState, 'ALL_CHATS' | 'MY_CHATS' | 'UNASSIGNED' | 'SLA_STATUS'>,
  ChatStatuses[]
> = {
  [FiltersState.ALL_CHATS]: [
    ChatStatuses.UNRESOLVED,
    ChatStatuses.DONE,
    ChatStatuses.WAITING_FOR_RESPONSE,
    ChatStatuses.UNREAD,
    ChatStatuses.ALL,
  ],
  [FiltersState.MY_CHATS]: [
    ChatStatuses.UNRESOLVED,
    ChatStatuses.DONE,
    ChatStatuses.WAITING_FOR_RESPONSE,
    ChatStatuses.UNREAD,
    ChatStatuses.ALL,
  ],
  [FiltersState.UNASSIGNED]: [ChatStatuses.UNRESOLVED, ChatStatuses.DONE, ChatStatuses.UNREAD, ChatStatuses.ALL],
  [FiltersState.SLA_STATUS]: [ChatStatuses.WAITING_FOR_RESPONSE, ChatStatuses.UNREAD, ChatStatuses.ALL],
};

const INBOX_FILTER_TYPES: Array<
  keyof Pick<typeof FiltersState, 'ALL_CHATS' | 'MY_CHATS' | 'UNASSIGNED' | 'SLA_STATUS'>
> = [FiltersState.ALL_CHATS, FiltersState.MY_CHATS, FiltersState.SLA_STATUS, FiltersState.UNASSIGNED];

export function normalizeFilterCountsForUi(filterCounts: GetChatStatusFilterCount[]): GetChatStatusFilterCount[] {
  return (filterCounts ?? []).map((filterCount) => ({
    ...filterCount,
    counts: (filterCount.counts ?? []).filter(({ count }) => typeof count === 'string'),
  }));
}

/**
 * Client-only placeholder so the filter column can render before POST /v1/search/filters/count returns.
 * Replaced by real API data; may briefly show tabs the user cannot access.
 * Per-row count badges stay hidden while `chatStatusFilterCountsLoading` is true in `ChatFilters`.
 */
export function buildPlaceholderChatFilterCounts(): GetChatStatusFilterCount[] {
  return INBOX_FILTER_TYPES.map((type) => {
    const meta = CHAT_FILTER_TYPES.find((t) => t.type === type);
    const statuses = STATUS_ROWS_BY_FILTER_TYPE[type];
    return {
      type,
      label: meta?.label ?? type,
      counts: statuses.map((status) => ({
        type: status,
        label: labelForStatus(status),
        count: '0',
      })),
    };
  });
}
